/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Event type enum value.
 */
export enum ITKSECEventTypes {
    User_Created_Create = 610101,
    /**
     * Data1: Old Name , Data2 : New Name
     */
    User_MasterDataChanged_Name = 610201,
    /**
     * Data1: Old Email , Data2 : New Email
     */
    User_MasterDataChanged_Email = 610203,
    /**
     * Data1: Permission ID
     */
    User_Permissions_PersmissionAdded = 610301,
    /**
     * Data1: Permission ID
     */
    User_Permissions_PersmissionRemoved = 610302,
    /**
     * Data1: Role ID
     */
    User_Permissions_RoleAdded = 610303,
    /**
     * Data1: Role ID
     */
    User_Permissions_RoleRemoved = 610304,
    /**
     * Lock user of user entity
     */
    User_Locked_Lock = 610401,
    User_Locked_UnLock = 610402,
    User_Deleted_Delete = 610501,
}
